var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTablerIconCameraPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 26.6666C22.7614 26.6666 25 24.428 25 21.6666C25 18.9052 22.7614 16.6666 20 16.6666C17.2386 16.6666 15 18.9052 15 21.6666C15 24.428 17.2386 26.6666 20 26.6666Z",
    stroke: "#59359a",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.66663H16.6667C16.2246 6.66663 15.8007 6.84222 15.4882 7.15478C15.1756 7.46734 15 7.89127 15 8.33329C15 9.21735 14.6488 10.0652 14.0237 10.6903C13.3986 11.3154 12.5507 11.6666 11.6667 11.6666H8.33333C7.44928 11.6666 6.60143 12.0178 5.97631 12.6429C5.35119 13.2681 5 14.1159 5 15V30C5 30.884 5.35119 31.7319 5.97631 32.357C6.60143 32.9821 7.44928 33.3333 8.33333 33.3333H31.6667C32.5507 33.3333 33.3986 32.9821 34.0237 32.357C34.6488 31.7319 35 30.884 35 30V18.3333",
    stroke: "#59359a",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 10H35",
    stroke: "#59359a",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 5V15",
    stroke: "#59359a",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerIconCameraPlus);
export default __webpack_public_path__ + "static/media/tabler-icon-camera-plus.e08f2783a7e042f635af02accff0444b.svg";
export { ForwardRef as ReactComponent };